import { isIdXboxGameInformationSupplementaryDataFormValid } from "../../../../helpers/formValidation";
import { GameInformationSupplementaryDataType, SubFormsDataTypes } from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const SupplementaryDataDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const supplementaryData = data as GameInformationSupplementaryDataType;
    if (!supplementaryData) {
      return { result: true };
    }

    const validSchema = await isIdXboxGameInformationSupplementaryDataFormValid(supplementaryData);
    return { result: validSchema };
  },
};
